import { NO_DECIMAL_FORMAT, deriveCurrencyFormat } from '../../i18n/currencies';
import { COUNTRY_MAPPING } from '../../i18n/i18n.language-config';
import type { AccountTableInfoDto } from '../../types/accounts/tables/account-table-info.dto';

export function getProjectedRevenue(
  account: Pick<AccountTableInfoDto, 'country' | 'totalRevenue' | 'revenue'>
) {
  const language = COUNTRY_MAPPING[account.country];

  return deriveCurrencyFormat(
    language,
    account.totalRevenue ?? account.revenue,
    NO_DECIMAL_FORMAT
  );
}
